export function noDefault(value: never): any {
  throw new Error(`Unexpected value: ${value}`);
}
